module.exports = __webpack_public_path__ + "644ea0edaa840b27fea1a48bdafcb0ab.jpg";